/**
 * This is a reusable component for logging Axios errors in a more structured and pretty format.
 * It uses console.group to organize the error information neatly.
 */

const logAxiosError = (error) => {
    console.group('Axios Error Log');
    if (error.response) {
        // Axios error with response (e.g., server responded with a status code that falls out of the range of 2xx)
        console.error('Type: Axios Error');
        console.error(`Status: ${error.response.status}`);
        console.error('Data:', error.response.data);
        console.error('Headers:', error.response.headers);
    } else if (error.request) {
        // Axios error without response (e.g., request was made but no response was received)
        console.error('Type: Axios Error - No Response');
        console.error('Request:', error.request);
    } else {
        // Non-Axios error (e.g., something happened in setting up the request that triggered an Error)
        console.error('Type: Non-Axios Error');
        console.error('Message:', error.message);
    }
    console.groupEnd();
};

export default logAxiosError;